/* global MicroModal */
MicroModal.init({
  disableFocus: true,
});
